const data = ['toddler'];

export default data;
